export default {
    EN: 'en',
    ES: 'es',
    JA: 'ja'
};
